

















import {defineComponent, computed, WritableComputedRef} from "@vue/composition-api";
import {useActions, useGetters} from "vuex-composition-helpers";

export default defineComponent({
    name: "SearchBarMolecule",
    setup: () => {
        const {config, getSearchQuery} = useGetters(['config', 'getSearchQuery']);
        const {setSearchQuery} = useActions(['setSearchQuery']);
        const searchQuery: WritableComputedRef<string> = computed({
            get(): any {
                return getSearchQuery.value
            },
            set(value: string): void {
                setSearchQuery(value)
            },
        });
        return {
            config,
            searchQuery
        }
    }
})
